import React from 'react';

interface Props {
    briefType: 'video' | 'photo';
}

export default class BriefPaymentHero extends React.Component<Props> {
    render() {
        return (
            <div className="hero-layout hero-layout--smartshoot-payment">
                <div className="row">
                    <div className="column">
                        <h1 className="heading heading--h0 heading--with-divider">Your summary</h1>
                        <p className="paragraph paragraph--root paragraph--narrow-widescreen paragraph--offset">
                            Here’s a quick summary of your {this.props.briefType} project. You can
                            always change and discuss details with your filmmaker later.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}
